@if(formGroup().get(id()); as nameControl)
{
    @if(nameControl.invalid && (nameControl.dirty || nameControl.touched))
    {
                            
        <div [id]="id() + '-errors'" class="invalid-feedback d-block" role="alert">

            @if (nameControl.errors['required'])
            {
                <required-validation-error [label]="label()" />                
            }

            @if (nameControl.errors['email'])
            {
                <email-validation-error [label]="label()" />
            }
            
            @if (nameControl.errors['pattern'])
            {
                <pattern-validation-error [label]="label()" />
            }

            @if (nameControl.errors['min'])
                {
                    <min-validation-error 
                        [label]="label()" 
                        [min]="nameControl.errors['min'].min" />
                }

                @if (nameControl.errors['max'])
                {
                    <max-validation-error 
                        [label]="label()" 
                        [max]="nameControl.errors['max'].max" />
                }

        </div>
    }
    @else {
        <div class="valid-feedback d-block" role="alert">&nbsp;</div>
    }
}